resourcePaths = '{"rootPath":"","assetsPath":""}';/*
    ExpressionParser

    Takes an expression containing logical operators &&, ||, !. Supports parentheses.
    Provides methods for parsing and evaluating the expression.

    Methods (see methods for additional usage):

        convertToPostfix(expression)

        evaluate(postfixExpression)

*/
function ExpressionParser() {
    // Higher number specifies higher precedence
    this._precedenceTable = {
        "||" : 5,
        "&&" : 6,
        "==" : 10,
        "!=" : 10,
        "<"  : 11,
        "<=" : 11,
        ">"  : 11,
        ">=" : 11,
        "!"  : 15
    };
}

/*
    Converts a given expression in infix format and converts the expression to
    a postfix format.

    Arguments:
        expression [string] (required):
            The expression (infix format) to be converted to postfix format.

    Returns:
        [Array]
            The postfix format of the expression, represented in an array.

*/
ExpressionParser.prototype.convertToPostfix = function(expression) {
    expression = this._splitExpression(expression);
    var expressionStack = [];
    var postFix = [];
    for (var i = 0; i < expression.length; i++) {
        var current = expression[i];
        if (!this.isSupportedOperator(current) && //not in the operators
            current != "(" &&
            current != ")") {

            postFix.push(current);
        } else {
            if (current === "(") {
                expressionStack.push(current);
            } else if (current === ")") {
                while (expressionStack.peek() != "(")
                    postFix.push(expressionStack.pop());
                expressionStack.pop();
            } else {
                while (expressionStack.length > 0 && this._checkPrecedence(expressionStack.peek(), current) === 1) {
                    postFix.push(expressionStack.pop());
                }
                expressionStack.push(current);
            }
        }
    }
    while (expressionStack.length > 0)
        postFix.push(expressionStack.pop());

    return postFix;
};

/*
    Evaluates a postfix expression and returns the result of that expression.

    Arguments:
        postfixExpression [Array] (required):
            The expression (in postfix format, represented as an array) to be evaluated.

    Returns:
        [boolean]
            The result of evaluating the expression, true or false.
*/
ExpressionParser.prototype.evaluate = function(postfixExpression) {
    var resultStack = [];
    var temp, temp1, temp2;

    for (var i = 0; i < postfixExpression.length; i++) {
        var current = postfixExpression[i];
        if (typeof current == "boolean" || typeof current == "object") {
            resultStack.push(current);
        } else if (typeof current == "string") {
            //check for operators
            if (current === "!") {
                temp = this._evalArray(resultStack.pop(), 0);

                temp = !temp;
                resultStack.push(temp);

            } else if (current === "==" || current === "!=") {
                temp1 = this._evalArray(resultStack.pop(), 1);
                temp2 = this._evalArray(resultStack.pop(), 1);

                if (current === "==")
                    resultStack.push(temp1 == temp2);
                else
                    resultStack.push(temp1 != temp2);

            } else if (current === "||" || current === "&&") {
                temp1 = this._evalArray(resultStack.pop(), 0);
                temp2 = this._evalArray(resultStack.pop(), 0);

                if (current === "||")
                    resultStack.push(temp1 || temp2);
                else if (current === "&&")
                    resultStack.push(temp1 && temp2);

            } else if (current === "<" || current === "<=" ) {
                temp1 = parseInt(this._evalArray(resultStack.pop(), 1));
                temp2 = parseInt(this._evalArray(resultStack.pop(), 1));

                if (current === "<")
                    resultStack.push(temp2 < temp1);
                else
                    resultStack.push(temp2 <= temp1);

            } else if (current === ">" || current === ">=") {
                temp1 = parseInt(this._evalArray(resultStack.pop(), 1));
                temp2 = parseInt(this._evalArray(resultStack.pop(), 1));

                if (current === ">")
                    resultStack.push(temp2 > temp1);
                else
                    resultStack.push(temp2 >= temp1);
            } else {
                resultStack.push(current);
            }
        }
    }

    return this._evalArray(resultStack[0], 0);
};

ExpressionParser.prototype.isSupportedOperator = function(operator) {
    return this._precedenceTable[operator];
};

ExpressionParser.prototype._evalArray = function(obj, int) {
    if (obj !== null && typeof obj === "object")
        return obj[int];
    else
        return obj;
};

ExpressionParser.prototype._splitExpression = function(expression) {
    var resultStr = "";
    var lastChar = "";
    for (var i = 0; i < expression.length; i++) {
        if ((expression[i] === "|" && lastChar === "|") ||
            (expression[i] === "&" && lastChar === "&") ||
            (expression[i] === "=" && lastChar === "!") ||
            (expression[i] === "=" && lastChar === "=") ||
            (expression[i] === "=" && lastChar === ">") ||
            (expression[i] === "=" && lastChar === "<") ||
            (expression[i] === "!" && expression[i+1] !== "=")) {
            resultStr = resultStr + expression[i] + " ";

        } else if ((expression[i] === "<" && expression[i+1] !== "=") ||
                   (expression[i] === ">" && expression[i+1] !== "=")) {
            resultStr = resultStr + " " + expression[i] + " ";

        } else if (expression[i] === "|" ||
                   expression[i] === "&" ||
                   expression[i] === "=" ||
                   expression[i] === "!" ||
                   expression[i] === "<" ||
                   expression[i] === ">") {
            resultStr = resultStr + " " + expression[i];

        } else if (expression[i] === "(" ||
                   expression[i] === ")") {
            resultStr = resultStr + " " + expression[i] + " ";

        } else {
            resultStr = resultStr + expression[i];
        }

        lastChar = resultStr[resultStr.length - 1];
    }

    var tempArr = this._splitExpressionResults(resultStr);
    tempArr = tempArr.map(function(item) {
        if (item === "true" || item === "false")
            return JSON.parse(item);
        else
            return item;
    });

    return tempArr;
};

ExpressionParser.prototype._splitExpressionResults = function(str) {
    var quoteState = false;
    var outputIndex = 0;
    var output = [];
    var lastChar = null;

    for(var i = 0; i < str.length; i++) {
        if(str[i] === "'")
            quoteState = !quoteState;

        if(!quoteState && str[i] === " " && lastChar != " " && lastChar !== null)
            outputIndex++;

        if(typeof output[outputIndex] === "undefined" && str[i] !== " ")
            output[outputIndex] = "";

        if(str[i] !== " " || quoteState)
            output[outputIndex] += str[i];

        lastChar = str[i];
    }

    return output;
};

ExpressionParser.prototype._checkPrecedence = function(op1, op2) {
    var op1Prec = this._precedenceTable[op1];
    var op2Prec = this._precedenceTable[op2];
    if (op1Prec === op2Prec)
        return 0;
    else if (op1Prec > op2Prec)
        return 1;
    else if (op1Prec < op2Prec)
        return -1;
    else
        return -1;
};


/*
    Extends Array object to include a peek method.

    Returns:
        [Object]
            The last item in an array.
*/
Array.prototype.peek = function() {
    if (this.length > 0) {
        return this[this.length - 1];
    }
    return undefined;
};




/* TESTS */
//  var ExpressionChecksTests = [
//     ["true", true],
//     ["!false", true],
//     ["false", false],
//     ["!true", false],
//     ["true && !false", true],
//     ["false && !true", false],
//     ["true && true || false", true],
//     ["false && true || false", false],
//     ["false && false || true", true],
//     ["(true && false) || (false || true)", true],
//     ["false || true && true", true],
//     ["someString==someString", true],
//     ["someString!=someString", false],
//     ["someString==NotsomeString", false],
//     ["someString!=NotsomeString", true],
//     ["a==a || b==c", true],
//     ["a==a && b==c", false],
//     ["a==a && b!=c", true],
//     ["a==a && b==c || (a==b || a!=b)", true],
//     ["a==a && b==c || !(a==b || a!=a)", true],
//     ["false && b==c || !(a==b || a!=a)", true],
//     ["'hello there' == 'hello there'", true],
//     ["'hello there' != 'hello there'", false],
//     ["'hello there' == 'Not hello there'", false],
//     ["'hello there' != 'Not hello there'", true],
//     ["'hello there' != 'hello there' || true", true],
//     ["'hello there' == 'Not hello there' || true", true],
//     ["'hello there' == 'Not hello there' || (true && false)", false],
//     ["((true || false) && (!false || false))", true],
//     ["((true || false) && !false || false)", true],
//     ["'hello there' != 'Not hello there' || (true && false)", true],
//     ["6 > 9", false],
//     ["6 < 9", true],
//     ["6 <= 6", true],
//     ["6 >= 6", true],
//     ["6 <= 66", true],
//     ["6 >= 66", false],
//     ["(6 <= 66) && (6 >= 0)", true],
//     ["!(6 > 9)", true]
// ];
//
// var testEP = new ExpressionParser();
// for (var i = 0; i < ExpressionChecksTests.length; i++) {
//     var converted = testEP.convertToPostfix( ExpressionChecksTests[i][0] );
//     var evaluated = testEP.evaluate( converted );
//
//     var resultsObj = {
//         "Expression" : ExpressionChecksTests[i][0],
//         "Converted" : converted,
//         "Expected Result" :  ExpressionChecksTests[i][1],
//         "Actual Result" : evaluated
//     };
//
//     if (evaluated !== ExpressionChecksTests[i][1])
//         console.error(resultsObj);
//     else
//         console.log(resultsObj);
// }
